import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import { validateInspireForm } from '../giveWidget/giveWidgetFunctions.js';
// -*- mode: jsx;-*-

export const TeacherGiftCardWidget = createReactClass({

    propTypes: {
        teacherId: PropTypes.number.isRequired,
        teacherScreenName: PropTypes.string.isRequired,

        projectId: PropTypes.number, // only for instant fundraising
        cssClass: PropTypes.string,
        formId: PropTypes.string,
    },

    getDefaultProps: function () {
        return {
            cssClass: '',
            formId: 'inspireForm',
        };
    },

    onSubmit: function (event) {
        const valid = validateInspireForm(this.formHolder);
        if (!valid) {
            event.preventDefault();
        }
    },

    render: function () {
        const props = this.props;

        return (
            <form method="post"
                id={props.formId}
                action={secureBaseURL + 'donors/cart/teacher-gift-code'}
                onSubmit={this.onSubmit}
                className="form-redux"
                ref={(e) => { this.formHolder = e; }}>
                <input type="hidden" name="gift" value="true" />
                <input type="hidden" name="deliveryType" value="email" />
                <input type="hidden" name="gcToTeacher" value={props.teacherId} />
                <input type="hidden" name="intendedProjectId" value={props.projectId} />
                <input type="hidden" name="toName" value={props.teacherScreenName} />
                <input type="hidden" name="message" value="Use this toward your next classroom project!" />
                <div className="dollar-amount input-holder">
                    <input type="tel" className="donation-amount" id="amount" name="amount" />
                    <div className="inline-button">
                        <input className="button-primary small give-button heap-give-button" type="submit" value="Give" />
                    </div>
                </div>
            </form>
        );
    },
});
